module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Bold.f86b081a.otf";